export default __webpack_public_path__ + "static/media/microorganism-&-cell-transfer-solutions.9e5bde3b.png";